import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './contactus.css';

function ContactUs() {
   const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await emailjs.send(
        'service_hyvom0x', // Replace with your EmailJS service ID
        'template_4opyoct', // Replace with your EmailJS template ID
        formData,
        'lM41GBFi-wpxugewO' // Replace with your EmailJS public key
      );
      
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({ name: '', email: '', phone: '', service: '', message: '' });
      
      setTimeout(() => setSubmitStatus(null), 5000);
    } catch (error) {
      console.log('FAILED...', error);
      setIsSubmitting(false);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(null), 5000);
    }
  };

  return (
    <section className="eco-contact-page">

      {/* Hero Section */}
      <div className="eco-contact-hero">
        <div className="eco-contact-hero-content">
          <div className="eco-contact-hero-text">
            <h1>Get In <span className="eco-highlight">Touch</span></h1>
            <p>Experience eco-friendly transportation. Our team is ready to assist you with your travel needs.</p>

            <div className="eco-contact-features">
              <div className="eco-feature">
                <span>Instant Booking Confirmation</span>
              </div>
              <div className="eco-feature">
                <span>Best Price Guarantee</span>
              </div>
              <div className="eco-feature">
                <span>24/7 Travel Support</span>
              </div>
            </div>
          </div>

          <div className="eco-contact-hero-card">
            <h3>Emergency Booking</h3>
            <p>Need immediate assistance?</p>
        <a 
  href="tel:+94742947134" 
  className="eco-contact-phone"
  style={{ textDecoration: 'none' }}
>
  +94 74 294 7134
</a>

          </div>
        </div>
      </div>






<div className="eco-contact-form-section">
  <div className="eco-container">
    <div className="eco-form-header">
      <h2>Contact Us</h2>
      <p>Ready to experience premium eco-friendly transportation? We're here to help.</p>
       <img 
    src='/call-assistant.png' 
    alt='call assistant'
    style={{
      width: '100%',
      maxWidth: '400px',
      height: 'auto',
      margin: '0 auto',
      display: 'block'
    }}
  />
    </div>

    {submitStatus === 'success' && (
      <div className="eco-success-message">
        <div className="eco-success-content">
          <h4>Message Sent Successfully!</h4>
          <p>Thank you for contacting Eco Rich Travels. Our team will respond as soon as possible.</p>
        </div>
      </div>
    )}

    <form className="eco-contact-form" onSubmit={handleSubmit}>
      <div className="eco-form-grid">
        <div className="eco-form-group">
          <label htmlFor="name">Full Name *</label>
          <input
            id="name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="eco-form-group">
          <label htmlFor="email">Email Address *</label>
          <input
            id="email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="eco-form-group">
          <label htmlFor="phone">Phone Number</label>
          <input
            id="phone"
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>

        <div className="eco-form-group">
          <label htmlFor="service">Service Type</label>
          <select
            id="service"
            name="service"
            value={formData.service}
            onChange={handleChange}
          >
            <option value="">Select a Service</option>
            <option value="airport">Airport Transfer</option>
            <option value="city-tour">City Tour</option>
            <option value="corporate">Corporate Travel</option>
            <option value="wedding">Wedding Service</option>
            <option value="hourly">Hourly Rental</option>
            <option value="other">Other</option>
          </select>
        </div>
      </div>

      <div className="eco-form-group eco-form-group-full">
        <label htmlFor="message">Your Message *</label>
        <textarea
          id="message"
          name="message"
          placeholder="Tell us about your transportation needs..."
          rows="6"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
      </div>

      <button type="submit" disabled={isSubmitting} className="eco-submit-btn">
        {isSubmitting ? (
          <>
            <span className="eco-btn-spinner"></span>
            Sending Message...
          </>
        ) : (
          'Send Message'
        )}
      </button>
    </form>
  </div>
</div>








      {/* Contact Methods */}
      <div className="eco-contact-methods">
        <div className="eco-container">
          <div className="eco-methods-grid">
            <div className="eco-method-card">
              <h3>Email Us</h3>
              <p>Send us a message anytime</p>
              <a href="mailto:info@ecorichtravels.com">info@ecorichtravels.com</a>
            </div>

            <div className="eco-method-card">
              <h3>Call Us</h3>
              <p>Speak directly with our team</p>
              <a href="tel:+94742947134">+94 74 294 7134</a>
            </div>

            <div className="eco-method-card">
              <h3>Visit Us</h3>
              <p>Stop by our office</p>
              <address>
                520, Pamunugama Rd<br />
                Negombo, Sri Lanka
              </address>
            </div>
          </div>
        </div>
      </div>



<div className="eco-contact-map">
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3959.3381568758336!2d79.84991867448386!3d7.086741416362961!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2efdcaf242c87%3A0x37656c68295e78ab!2sEco%20rich%20villa!5e0!3m2!1sen!2slk!4v1762284575130!5m2!1sen!2slk"
    title="Eco Rich Villa Location"
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>




    </section>
  );
}

export default ContactUs;
